import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { VinSearchResultView } from "../vinSearch/VinSearchResultView"

export interface GetVinSearchResultViewPathParams {
	vin: string
}

export const getVinSearchResultViewRoute: ApiRoute<
	GetVinSearchResultViewPathParams,
	NoQueryParams,
	NoBody,
	VinSearchResultView
> = {
	buildUrl: (params) => `/vin-search/${params.vin}`,
	method: "get",
	path: "/vin-search/:vin",
}
